import { render, staticRenderFns } from "./nipigeloader.vue?vue&type=template&id=190fd573&scoped=true"
import script from "./nipigeloader.vue?vue&type=script&lang=js"
export * from "./nipigeloader.vue?vue&type=script&lang=js"
import style0 from "./nipigeloader.vue?vue&type=style&index=0&id=190fd573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fd573",
  null
  
)

export default component.exports